'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alert = function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert(props) {
    _classCallCheck(this, Alert);

    var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));

    _this.state = {
      open: _this.props.open,
      dismissable: _this.props.dismissable,
      fadeIn: true
    };
    _this.onClose = _this.onClose.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(Alert, [{
    key: 'onClose',
    value: function onClose() {
      this.setState({
        open: false
      });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _this2 = this;

      this.setState({
        fadeIn: false
      });
      this.clickTimeOutId = setTimeout(function () {
        _this2.onClose();
      }, this.props.transitionDuration);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.open !== this.props.open) {
        this.setState({
          open: nextProps.open
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.clickTimeOutId) {
        clearTimeout(this.clickTimeOutId);
      }
      if (this.autoCloseTimeOutId) {
        clearTimeout(this.autoCloseTimeOutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          type = _props.type;

      var alertClasses = void 0;
      var iconClasses = void 0;
      var isNotice = false;
      if (type) {
        switch (type) {
          case 'success':
            alertClasses = 'alert-success';
            iconClasses = 'type-icon info pull-left fa fa-check';
            break;
          case 'info':
            alertClasses = 'alert-info';
            iconClasses = 'type-icon info pull-left fa fa-info';
            break;
          case 'warning':
            alertClasses = 'alert-warning';
            iconClasses = 'type-icon info pull-left fa fa-minus';
            break;
          case 'danger':
          case 'error':
            alertClasses = 'alert-error';
            iconClasses = 'type-icon info pull-left fa fa-exclamation';
            break;
          case 'notice-success':
            alertClasses = 'alert-success';
            isNotice = true;
            break;
          case 'notice-info':
            alertClasses = 'alert-info';
            isNotice = true;
            break;
          case 'notice-warning':
            alertClasses = 'alert-warning';
            isNotice = true;
            break;
          case 'notice-danger':
          case 'notice-error':
            alertClasses = 'alert-error';
            isNotice = true;
            break;
          default:
            alertClasses = 'alert-info';
            iconClasses = 'type-icon info pull-left fa fa-info';
        }
      }

      if (this.state.open) {
        if (this.props.autoCloseTime !== -1 && !this.autoCloseTimeOutId) {
          this.autoCloseTimeOutId = setTimeout(function () {
            return _this3.handleClick();
          }, this.props.autoCloseTime);
        }
        return _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)("alert fade", { "fe-alert": !isNotice }, { "fe-notice": isNotice }, alertClasses, className, { "in": this.state.fadeIn }, { "alert-dismissible": this.state.dismissable }), role: 'alert' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: (0, _classnames2.default)("close", { "hidden": !this.state.dismissable }), onClick: this.handleClick, 'aria-label': 'Close' },
            _react2.default.createElement('i', { className: 'fa fa-close' })
          ),
          !isNotice ? _react2.default.createElement('div', { className: iconClasses }) : null,
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)({ "fe-notice__content": isNotice }, { "fe-alert__content pull-left": !isNotice }) },
            children
          )
        );
      } else {
        return null;
      }
    }
  }]);

  return Alert;
}(_react2.default.Component);

Alert.propTypes = {
  onClose: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  dismissable: _propTypes2.default.bool,
  transitionDuration: _propTypes2.default.number,
  autoCloseTime: _propTypes2.default.number,
  type: _propTypes2.default.string
};

Alert.defaultProps = {
  open: true,
  dismissable: true,
  transitionDuration: 150,
  autoCloseTime: -1
};

exports.default = Alert;